import { computed, toValue } from "vue";
const useStateClass = (value) => computed(() => {
  const resolvedValue = toValue(value);
  return resolvedValue === true ? "is-valid" : resolvedValue === false ? "is-invalid" : null;
});
export {
  useStateClass as u
};
//# sourceMappingURL=useStateClass-BGbSLWFN.mjs.map
